// Theme: supernova
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'supernova',
  name: 'SUPERNOVA',
  tagline: 'SUPERNOVA',
  description: 'Explosao estelar rosa-vermelho de alta energia.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0F0408', '#200A10', '#F43F5E', '#FFE4E6'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-supernova'
  },
  colorVars: {
    '--accent': '#F43F5E',
    '--accent-foreground': '#0F0408',
    '--background': '#0F0408',
    '--border': '#8A2040',
    '--card': '#200A10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFE4E6',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F0408',
    '--foreground': '#FFE4E6',
    '--hold-fill': '#F43F5E',
    '--input': '#8A2040',
    '--modal-bg': '#0F0408',
    '--modal-border': '#8A2040',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A2040',
    '--muted-foreground': '#FFE4E6',
    '--nav-active': '#F43F5E',
    '--nav-bg': '#200A10',
    '--popover': '#200A10',
    '--popover-foreground': '#FFE4E6',
    '--primary': '#F43F5E',
    '--primary-foreground': '#0F0408',
    '--ring': '#F43F5E',
    '--secondary': '#8A2040',
    '--secondary-foreground': '#FFE4E6',
    '--streak': '#F43F5E',
    '--success': '#22c55e',
    '--success-foreground': '#0F0408',
    '--xp': '#F43F5E',
    '--xp-bg': '#200A10'
  },
  resolvedVars: {
    '--accent': '#F43F5E',
    '--accent-foreground': '#0F0408',
    '--accent-foreground-hsl': '338 58% 4%',
    '--accent-foreground-oklch': 'from #0F0408 l c h',
    '--accent-hsl': '350 89% 60%',
    '--accent-oklch': 'from #F43F5E l c h',
    '--background': '#0F0408',
    '--background-hsl': '338 58% 4%',
    '--background-oklch': 'from #0F0408 l c h',
    '--border': '#8A2040',
    '--border-hsl': '342 62% 33%',
    '--border-oklch': 'from #8A2040 l c h',
    '--border-w': '1px',
    '--card': '#200A10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFE4E6',
    '--card-foreground-hsl': '356 100% 95%',
    '--card-foreground-oklch': 'from #FFE4E6 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '344 52% 8%',
    '--card-oklch': 'from #200A10 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F0408',
    '--destructive-foreground-hsl': '338 58% 4%',
    '--destructive-foreground-oklch': 'from #0F0408 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFE4E6',
    '--foreground-hsl': '356 100% 95%',
    '--foreground-oklch': 'from #FFE4E6 l c h',
    '--hold-fill': '#F43F5E',
    '--hold-fill-hsl': '350 89% 60%',
    '--hold-fill-oklch': 'from #F43F5E l c h',
    '--input': '#8A2040',
    '--input-hsl': '342 62% 33%',
    '--input-oklch': 'from #8A2040 l c h',
    '--modal-bg': '#0F0408',
    '--modal-bg-hsl': '338 58% 4%',
    '--modal-bg-oklch': 'from #0F0408 l c h',
    '--modal-border': '#8A2040',
    '--modal-border-hsl': '342 62% 33%',
    '--modal-border-oklch': 'from #8A2040 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A2040',
    '--muted-foreground': '#FFE4E6',
    '--muted-foreground-hsl': '356 100% 95%',
    '--muted-foreground-oklch': 'from #FFE4E6 l c h',
    '--muted-hsl': '342 62% 33%',
    '--muted-oklch': 'from #8A2040 l c h',
    '--nav-active': '#F43F5E',
    '--nav-active-hsl': '350 89% 60%',
    '--nav-active-oklch': 'from #F43F5E l c h',
    '--nav-bg': '#200A10',
    '--nav-bg-hsl': '344 52% 8%',
    '--nav-bg-oklch': 'from #200A10 l c h',
    '--popover': '#200A10',
    '--popover-foreground': '#FFE4E6',
    '--popover-foreground-hsl': '356 100% 95%',
    '--popover-foreground-oklch': 'from #FFE4E6 l c h',
    '--popover-hsl': '344 52% 8%',
    '--popover-oklch': 'from #200A10 l c h',
    '--primary': '#F43F5E',
    '--primary-foreground': '#0F0408',
    '--primary-foreground-hsl': '338 58% 4%',
    '--primary-foreground-oklch': 'from #0F0408 l c h',
    '--primary-hsl': '350 89% 60%',
    '--primary-oklch': 'from #F43F5E l c h',
    '--radius': '12px',
    '--ring': '#F43F5E',
    '--ring-hsl': '350 89% 60%',
    '--ring-oklch': 'from #F43F5E l c h',
    '--secondary': '#8A2040',
    '--secondary-foreground': '#FFE4E6',
    '--secondary-foreground-hsl': '356 100% 95%',
    '--secondary-foreground-oklch': 'from #FFE4E6 l c h',
    '--secondary-hsl': '342 62% 33%',
    '--secondary-oklch': 'from #8A2040 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#F43F5E',
    '--streak-hsl': '350 89% 60%',
    '--streak-oklch': 'from #F43F5E l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F0408',
    '--success-foreground-hsl': '338 58% 4%',
    '--success-foreground-oklch': 'from #0F0408 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(350 89% 60% / 0.15)',
    '--xp': '#F43F5E',
    '--xp-bg': '#200A10',
    '--xp-bg-hsl': '344 52% 8%',
    '--xp-bg-oklch': 'from #200A10 l c h',
    '--xp-hsl': '350 89% 60%',
    '--xp-oklch': 'from #F43F5E l c h'
  }
}
